import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AUTH_CONSTANTS } from '../constants/auth.constants';

export const authGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);

  // Handle callback route first
  if (location.pathname.includes(AUTH_CONSTANTS.ROUTES.LOGIN_CALLBACK)) {
    return true;
  }

  // Check if user has valid cookie (for performance) - FASTEST CHECK
  const userFromCookie = authService.getUserFromCookie();
  if (userFromCookie) {
    return true;
  }

  // If no cookie, check Okta authentication state
  const isAuthenticated = await authService.isAuthenticated();
  if (!isAuthenticated) {
    // Start redirect immediately to prevent content flash
    authService.signIn();
    return false;
  }

  return true;
};
